import Vue from 'vue'
import i18n from '@web/assets/i18n'

export const handleToast = (error, callerName) => {
  if (error.response?.status === 500) {
    return
  }

  if (error.response?.status === 404 && callerName) {
    Vue.$toast.error(i18n.t('global.errors.error_404', { name: callerName }))
  } else {
    Vue.$toast.error(error.message)
  }
}

export const convertMonthToEnMonth = (month) => {
  if (!month) {
    return null
  }

  switch (month.toLowerCase()) {
    case 'január':
      return 'January'
    case 'február':
      return 'February'
    case 'marec':
      return 'March'
    case 'apríl':
      return 'April'
    case 'máj':
      return 'May'
    case 'jún':
      return 'June'
    case 'júl':
      return 'July'
    case 'august':
      return 'August'
    case 'september':
      return 'September'
    case 'október':
      return 'October'
    case 'november':
      return 'November'
    case 'december':
      return 'December'
    case 'dnes':
      return 'Today'
    default:
      return month
  }
}
